<rask-page pageTitle="{{ 'LEVERANTOR_LIST_SOK' | translate }}" noPadding>
  <ng-container header>
    @if (canMoveLeverantorer()) {
      <rask-action-button icon="fas fa-arrows-rotate" (click)="moveLeverantorer()">
        <rask-header noPadding>Flytta leverantörer</rask-header>
      </rask-action-button>
    }
    <rask-action-button icon="fas fa-plus" (click)="addNewAnbudsleverantor()">
      <rask-header noPadding>{{ 'VIRKESKOP_ANBUD_KONTRAKT_DETAIL_SKAPA_NY_LEVERANTOR' | translate }}</rask-header>
    </rask-action-button>
  </ng-container>
  @if (form) {
    <ng-container headerContent>
      <form [formGroup]="form" (ngSubmit)="search()">
        <div class="row">
          <div class="col-8">
            <div class="row">
              <rask-input aid="inputSok" class="col-3"
                label="{{ 'LEVERANTOR_LIST_ORDERSOK_PLACEHOLDER' | translate }}"
              formControlName="sok"></rask-input>
              <rask-input aid="inputLimeId" class="col-3" label="{{ 'LEVERANTOR_LABEL_LIMEID' | translate }}"
              formControlName="limeId"></rask-input>
              <rask-input aid="inputAdressParam" class="col-3"
                label="{{ 'LEVERANTOR_LABEL_ADRESS' | translate }}"
              formControlName="adressParam"></rask-input>
              <rask-input aid="inputTelefonParam" class="col-3"
                label="{{ 'LEVERANTOR_LABEL_TELEFON' | translate }}"
              formControlName="telefonParam"></rask-input>
            </div>
            <div class="row">
              <rask-search
                aid="inputAnsvarigVirkeskopare"
                class="col-3"
                label="{{'LEVERANTOR_LABEL_ANSV_VIRKESKOPARE' | translate}}"
                bindLabel="namn"
                bindValue="kod"
                formControlName="ansvarigVirkeskopare"
                typeToSearchText="{{ 'LEVERANTOR_DETAIL_TYPE_AHEAD_HELP_TEXT' | translate }}"
                loadingText="Laddar..."
                notFoundText="Ingen träff"
                [minTermLength]="3"
                [typeaheadFn]="getAnvandareTypeAhead"
                [selected]="form.value.ansvarigVirkeskopare">
              </rask-search>
              <rask-tree-selector
                class="col-3"
                label="Leverantörsklassning"
                [items]="leverantorklassningOptions"
                [required]="false"
                aid="inputKlassning"
                formControlName="klassning">
              </rask-tree-selector>
              <rask-selector
                class="col-3"
                aid="inputLeverantorsstatus"
                label="Leverantörsstatus"
                [values]="leverantorsstatusOptions"
                [formatter]="formatter"
                [viewFormatter]="textFormatter"
                [required]="false"
                formControlName="leverantorsstatus">
              </rask-selector>
              <div class="col-3 d-flex mt-auto">
                <rask-submit-button
                  aid="buttonSok"
                  class="ps-0"
                color="secondary">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
                <rask-button
                  aid="buttonRensa"
                  color="secondary"
                  negative
                (click)="reset()">{{ 'DEFAULT_BUTTON_LABEL_RENSA' | translate }}</rask-button>
              </div>
            </div>
          </div>
          <div class="col d-flex flex-column">
            <rask-radiobutton-group
              label="Vill ha almanackan"
              formControlName="villHaAlmanackan"
              [buttons]="villHaAlmanackanButtons">
            </rask-radiobutton-group>
            <div class="mt-auto ms-auto">
              <rask-button
                [disabled]="!leverantorer || leverantorer.length === 0"
                color="secondary"
                (click)="onMailAllClicked()"
                aid="buttonMailAll">
                E-posta samtliga i sökresultaten
              </rask-button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  }
  <rask-virkesleverantor-list [leverantorer]="leverantorer" [autoOpenLeverantor]="autoOpenLeverantorId"></rask-virkesleverantor-list>
</rask-page>